var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "LostModuleDashboard"
  }, [_c('div', {
    staticClass: "animated fadeIn"
  }, [_c('legend', [_vm._v("Check NDR/NPR Shipment Verification ")]), _vm._v(" "), _c('div', {
    staticClass: "card-headerfrm",
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_c('form', {
    attrs: {
      "data-vv-scope": "form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.formSubmit('form')
      }
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_vm._m(0), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-user'></i>"
    }
  }, [_c('basic-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.typeList,
      "selected-option": _vm.selectedTypeObj,
      "name": "type",
      "placeholder": "Select Type"
    },
    on: {
      "select": _vm.afterTypeSelected
    },
    model: {
      value: (_vm.type),
      callback: function($$v) {
        _vm.type = $$v
      },
      expression: "type"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form.type')),
      expression: "errors.has('form.type')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('form.type')))])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.type == 1),
      expression: "type==1"
    }],
    staticClass: "col-md-4"
  }, [_vm._m(1), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-user'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.srId),
      expression: "srId"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: (_vm.type == 1 ? 'required|numeric' : ''),
      expression: "type == 1 ? 'required|numeric' : ''"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "name": "srId",
      "maxlength": "9",
      "placeholder": "Enter SR ID"
    },
    domProps: {
      "value": (_vm.srId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.srId = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form.srId')),
      expression: "errors.has('form.srId')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('form.srId')))])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.type == 2),
      expression: "type==2"
    }],
    staticClass: "col-md-4"
  }, [_vm._m(2), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-user'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shippingId),
      expression: "shippingId"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: (_vm.type == 2 ? 'required' : ''),
      expression: " type == 2 ? 'required' : '' "
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "name": "shippingId",
      "placeholder": "Enter Shipping Id"
    },
    domProps: {
      "value": (_vm.shippingId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.shippingId = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form.shippingId')),
      expression: "errors.has('form.shippingId')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('form.shippingId')))])], 1), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "col-md-2"
  }, [_c('b-input-group', {
    staticClass: "topspace input-group"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-primary",
    staticStyle: {
      "margin-right": "20px"
    },
    attrs: {
      "type": "submit",
      "disabled": _vm.isLoading
    }
  }, [_vm._v("Submit")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-danger",
    staticStyle: {
      "margin-right": "20px"
    },
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading
    },
    on: {
      "click": _vm.resetForm
    }
  }, [_vm._v("Reset")])])], 1)])])]), _vm._v(" "), (_vm.showTable) ? _c('div', {
    staticClass: "form-group row overflow-auto"
  }, [_c('div', {
    staticClass: "col-md-5 ml-3"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "SRListing",
    class: {
      row: true,
      tableFixHead1: true
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables SetTripConfig",
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._m(3), _vm._v(" "), _c('tbody', {
    staticClass: "text-center"
  }, [_vm._l((_vm.ndpNprListData), function(data, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.ShippingId))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.CallStatus))])])
  }), _vm._v(" "), (_vm.ndpNprListData == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "9",
      "align": "center"
    }
  }, [_vm._v("No record found")])]) : _vm._e()], 2)])])], 1)]) : _vm._e()])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Type :"), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("SRId :"), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Shipping Id :"), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Sr No.")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("ShippingId")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Call Status")])])])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-09337c49","hasScoped":true}!./src/views/components/CheckNdrNprVerification/CheckNdrNprVerification.component.html
// module id = 1385
// module chunks = 1